import { queryOptions } from "@tanstack/react-query";
import * as avatarApi from "./avatar-api";

export const avatarQueries = {
  all: () => ["avatar"] as const,
  avatars: () => [...avatarQueries.all(), "avatars"] as const,
  download: (storageName: string, path: string) =>
    queryOptions({
      queryKey: [...avatarQueries.avatars(), "download", storageName, path],
      queryFn: () => avatarApi.downloadAvatar(storageName, path),
    }),
  publicUrl: (storageName: string, path: string) =>
    queryOptions({
      queryKey: [...avatarQueries.avatars(), "publicUrl", storageName, path],
      queryFn: () => avatarApi.getPublicUrl(storageName, path),
      staleTime: 60 * 60 * 1000, // 1 hour
      gcTime: 2 * 60 * 60 * 1000, // 2 hours
    }),
  signedUrl: (storageName: string, path: string, expiresInSeconds = 60 * 60) =>
    queryOptions({
      queryKey: [...avatarQueries.avatars(), "signedUrl", storageName, path],
      queryFn: () => avatarApi.getSignedUrl(storageName, path, expiresInSeconds),
      staleTime: (expiresInSeconds - 60) * 1000, // refresh 1 minute before expiry
      gcTime: expiresInSeconds * 1000,
    }),
};
